<template>
  <div class="w-10/12">
    <!-- Hidden file input for uploads -->
    <input
      ref="fileInput"
      type="file"
      style="display: none"
      @change="handleFileUpload"
      accept=".pdf,.doc,.docx,.xlsx,.csv,.ppt,.png,.jpg,.jpeg"
    />
    <div style="height: 100%" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>
    <div v-else class="mt-6">
      <div class="w-full">
        <p class="font-semibold mb-5 inline-block">Education & Certification</p>
        <span
          v-if="!cannotEdit"
          class="float-right cursor-pointer text-flame text-base font-semibold"
        >
          <span @click="handleClick" v-if="!edit">
            <icon icon-name="icon-edit" size="xs" class="inline-block" />
            <span class="pl-2">Edit</span>
          </span>
        </span>
      </div>

      <Certificate
        certificate-title="Educational Credentials"
        :is-edit="edit"
        :certificate-info="educationalInfo"
        certificate-type="educational"
        @add-info="addCredentials"
        @delete-educational-info="deleteEducationalInfo"
        @update-file-path="updateEducationalFilePath"
      />

      <Certificate
        certificate-title="Professional Certifications"
        :is-edit="edit"
        :certificate-info="certificationInfo"
        certificate-type="certification"
        @add-info="addCertifications"
        @delete-educational-info="deleteCertificationInfo"
        @update-file-path="updateCertificationFilePath"
      />

      <Certificate
        certificate-title="Professional Membership"
        :is-edit="edit"
        :certificate-info="membershipInfo"
        certificate-type="membership"
        @add-info="addMembership"
        @delete-educational-info="deleteMembershipInfo"
        @update-file-path="updateMembershipFilePath"
      />

      <Certificate
      certificate-title="Other Trainings"
      :is-edit="edit"
      :certificate-info="otherTrainingInfo"
      certificate-type="otherTraining"
      @add-info="addOtherTraining"
      @delete-educational-info="deleteOtherTrainingInfo"
      @update-file-path="updateOtherTrainingFilePath"
    />

      <div class="flex flex-col gap-2 mt-7 border p-4 rounded-lg">
        <div class="flex mt-2">
          <span class="text-sm font-semibold flex">Curriculum Vitae (Resume)</span>
        </div>
        <divider />

        <div class="my-5 flex items-center gap-5">
          <div v-if="!cvInfo.filePath" class=" text-dynamicBackBtn col-span-4 flex items-end gap-1 text-sm font-semibold cursor-pointer" @click="triggerCVUpload">
            <div class="w-5 h-5">
                <icon icon-name="red-upload-icon" size="xs" class="icon"/>
            </div>
            Upload CV
          </div>
          <div v-else class="col-span-4 flex items-end gap-1 text-sm font-semibold cursor-pointer" @click="downloadFile(cvInfo.filePath)">
            <div class="w-5 h-5">
                <icon v-if="cvInfo.filePath" icon-name="pdf" size="xs" class="icon"/>
                <icon v-else icon-name="red-upload-icon" size="xs" class="icon"/>
            </div>
            <div class="text-flame">{{ getFileName(cvInfo.filePath) }}</div>
          </div>
          <div class="col-span-1 flex items-center justify-end" v-if="edit && cvInfo.filePath">
            <span class="flex flex-col cursor-pointer justify-center my-4"
              @click="deleteCVInfo">
              <Icon icon-name="icon-trash" size="xs" class-name="text-desire" />
            </span>
          </div>
        </div>
      </div>



      <div v-if="edit" class="line"></div>

      <div v-if="edit" class="w-full h-16 flex justify-start items-end gap-1 mt-4">
        <Button @click="handleSave"
          class="text-white bg-dynamicBackBtn w-36 h-11 flex justify-center items-center"
        >
          Save
        </Button>
        <Button
        @click="getQualifications()"
        class="text-darkPurple bg-white w-20 h-11 flex justify-center items-center"
        >
          Cancel
        </Button>
      </div>
    </div>

    <Modal v-if="dialogDel">
      <Card class="p-5 flex flex-col max-w-md">
        <div class>
          <p class="font-bold ml-4 my-5 text-center">
            Are you sure you want to delete this Record?
          </p>
          <div class="flex">
            <Button
              class="text-white"
              @click="deleteQualification(dataId)"
              :background="appearance.buttonColor || defaultBTNColor"
            >
              Yes
            </Button>
            <Button
              background-color="none"
              class="text-dynamicBackBtn border border-solid border-dynamicBackBtn ml-4"
              @click="dialogDel = false"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Card>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Divider from "@/components/divider";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Card from "@/components/Card";
import Certificate from "@/components/Certificate";
import axios from 'axios';

export default {
  name: "EmployeeCertificate",
  components: {
    Divider,
    Modal,
    Card,
    Button,
    Certificate,
  },
  props: {
    cannotEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isUploaded: false,
      loading: true,
      dialogDel: false,
      edit: false,
      disable: true,
      educationalInfo: [
        {
          qualification: "",
          courseOfStudy: "",
          institution: "",
          yearOfAward: "",
          filePath: null,
        },
      ],
      certificationInfo: [
        {
          qualification: "",
          institution: "",
          yearOfAward: "",
          dateOfExpiration: "",
          filePath: null,
        },
      ],
      membershipInfo: [
        {
          qualification: "",
          institution: "",
          dateOfMembership: "",
          dateOfExpiration: null,
          filePath: null,
        },
      ],
      otherTrainingInfo: [
        {
          institution: "",
          qualification: "",
          yearOfAward: "",
          filePath: null,
        },
      ],
      cvInfo: {
        filePath: null,
      },
      dataId: "",
      // Upload tracking
      currentUploadType: null, // 'otherTraining', 'cv'
      currentUploadIndex: null,
    };
  },


  computed: {
    ...mapState({
      defaultBTNColor: (state) => state.orgAppearance.defaultBtnColor,
      appearance: (state) => state.orgAppearance.orgAppearanceData,
    }),

    shouldDisable() {
      // Check if any certificate section has valid data
      const hasEducationalData = !this.checkIsEmpty(this.educationalInfo) && !this.educationalInfo.every(item =>
        !item.institution.trim() && !item.qualification.trim() && !item.yearOfAward.trim()
      );

      const hasCertificationData = !this.checkIsEmpty(this.certificationInfo) && !this.certificationInfo.every(item =>
        !item.institution.trim() && !item.qualification.trim() && !item.yearOfAward.trim()
      );

      const hasMembershipData = !this.checkIsEmpty(this.membershipInfo) && !this.membershipInfo.every(item =>
        !item.institution.trim() && !item.qualification.trim() && !item.yearOfAward.trim()
      );

      const hasTrainingData = !this.checkIsEmpty(this.otherTrainingInfo) && !this.otherTrainingInfo.every(item =>
        !item.institution.trim() && !item.qualification.trim() && !item.yearOfAward.trim()
      );

      // Enable save if at least one certificate section has valid data
      const hasAnyValidData = hasEducationalData || hasCertificationData || hasMembershipData || hasTrainingData;

      return !hasAnyValidData; // Disable if no valid data exists
    },
  },

  watch: {
    shouldDisable(newValue) {
      this.disable = newValue;
    },
  },

  methods: {
    handleClick() {
      this.edit = !this.edit;
    },

    deleteEducationalInfo(position, data) {
      if (!data.id) {
        this.educationalInfo.splice(position, 1);
      } else {
        this.dataId = data.id;
        this.dialogDel = true;
      }
    },

    deleteCertificationInfo(position, data) {
      if (Object.values(data).every((value) => !value)) {
        this.certificationInfo.splice(position, 1);
      } else {
        this.dataId = data.id;
        this.dialogDel = true;
      }
    },

    handleSave() {
      const educationalInfoCheck = this.checkIsEmpty(this.educationalInfo);
      const certificationInfoCheck = this.checkIsEmpty(this.certificationInfo);
      const membershipInfoCheck = this.checkIsEmpty(this.membershipInfo);
      const otherTrainingInfoCheck = this.checkIsEmpty(this.otherTrainingInfo);

      const payload = {
        educationalInfo: !educationalInfoCheck
          ? this.educationalInfo.map(item => this.cleanCertificateData(item))
          : [],
        certificationInfo: !certificationInfoCheck
          ? this.certificationInfo.map(item => this.cleanCertificateData(item))
          : [],
        membershipInfo: !membershipInfoCheck
          ? this.membershipInfo.map(item => this.cleanCertificateData(item))
          : [],
        otherTrainingInfo: !otherTrainingInfoCheck
          ? this.otherTrainingInfo.map(item => this.cleanCertificateData(item))
          : [],
        cvInfo: this.cleanCVData(this.cvInfo),
      };

      this.$_createEmployeeCertifications(payload, this.$AuthUser.id)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 3000 });
          this.edit = false;
        })
        .catch((error) => {
          this.$toasted.error(error.message, { duration: 3000 });
        });
    },

    checkIsEmpty(arrData) {
      return arrData.every((obj) =>
        Object.keys(obj).every((key) => obj[key] === "" || obj[key] === null || obj[key] === undefined)
      );
    },

    checkIsFull(arrData) {
      // Check that required fields (institution, qualification, yearOfAward) are filled
      // filePath and dateOfExpiration are optional
      const requiredFields = ['institution', 'qualification', 'yearOfAward'];
      return arrData.every((obj) =>
        requiredFields.every((key) => obj[key] && obj[key] !== "")
      );
    },

    addCertifications() {
      this.certificationInfo.push({
        institution: "",
        qualification: "",
        yearOfAward: "",
        dateOfExpiration: null,
        filePath: null,
      });
    },

    addCredentials() {
      this.educationalInfo.push({
        institution: "",
        qualification: "",
        yearOfAward: "",
        filePath: null,
      });
    },

    addMembership() {
      this.membershipInfo.push({
        institution: "",
        qualification: "",
        yearOfAward: "",
        dateOfExpiration: null,
        filePath: null,
      });
    },

    addOtherTraining() {
      this.otherTrainingInfo.push({
        institution: "",
        qualification: "",
        yearOfAward: "",
        filePath: null,
      });
    },

    deleteMembershipInfo(position, data) {
      if (Object.values(data).every((value) => !value)) {
        this.membershipInfo.splice(position, 1);
      } else {
        this.dataId = data.id;
        this.dialogDel = true;
      }
    },

    deleteOtherTrainingInfo(position, data) {
      if (Object.values(data).every((value) => !value)) {
        this.otherTrainingInfo.splice(position, 1);
      } else {
        this.dataId = data.id;
        this.dialogDel = true;
      }
    },

    deleteCVInfo() {
      this.cvInfo.filePath = null;
    },

    updateEducationalFilePath(index, filePath) {
      if (this.educationalInfo[index]) {
        this.educationalInfo[index].filePath = filePath;
      }
    },

    updateCertificationFilePath(index, filePath) {
      if (this.certificationInfo[index]) {
        this.certificationInfo[index].filePath = filePath;
      }
    },

    updateMembershipFilePath(index, filePath) {
      if (this.membershipInfo[index]) {
        this.membershipInfo[index].filePath = filePath;
      }
    },

    updateOtherTrainingFilePath(index, filePath) {
      if (this.otherTrainingInfo[index]) {
        this.otherTrainingInfo[index].filePath = filePath;
      }
    },

    updateCVFilePath(filePath) {
      this.cvInfo.filePath = filePath;
    },

    triggerOtherTrainingUpload(index) {
      this.currentUploadType = 'otherTraining';
      this.currentUploadIndex = index;
      this.$refs.fileInput.click();
    },

    triggerCVUpload() {
      this.currentUploadType = 'cv';
      this.currentUploadIndex = null;
      this.$refs.fileInput.click();
    },

    getFileName(url) {
      if (!url) return 'Upload';
      const parts = url.split('/');
      const fileName = parts[parts.length - 1] || 'uploaded file';

      // Truncate filename if it's too long (max 30 characters)
      if (fileName.length > 30) {
        const extension = fileName.split('.').pop();
        const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
        const truncatedName = nameWithoutExt.substring(0, 30);
        return `${truncatedName}...${extension}`;
      }

      return fileName;
    },
    cleanCertificateData(item) {
      // Only include necessary fields for certificate data
      const cleanItem = {};

      // Always include these fields if they exist
      if (item.qualification) cleanItem.qualification = item.qualification;
      if (item.institution) cleanItem.institution = item.institution;
      if (item.filePath) cleanItem.filePath = item.filePath;

      // Include type-specific fields
      if (item.courseOfStudy) cleanItem.courseOfStudy = item.courseOfStudy;
      if (item.yearOfAward) cleanItem.yearOfAward = item.yearOfAward;
      if (item.dateOfExpiration) cleanItem.dateOfExpiration = item.dateOfExpiration;
      if (item.dateOfMembership) cleanItem.dateOfMembership = item.dateOfMembership;

      return cleanItem;
    },
    cleanCVData(cvInfo) {
      // Only include necessary fields for CV data
      const cleanCV = {};

      if (cvInfo.filePath) cleanCV.filePath = cvInfo.filePath;

      return cleanCV;
    },
    downloadFile(fileUrl) {
      if (!fileUrl) return;

      try {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = this.getFileName(fileUrl);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        this.$toasted.error('Failed to download file', { duration: 3000 });
      }
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'image/png',
        'image/jpeg',
        'image/jpg'
      ];

      if (!allowedTypes.includes(file.type)) {
        this.$toasted.error('Unsupported file type');
        return;
      }

      // Validate file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        this.$toasted.error('File size must be less than 5MB');
        return;
      }

      try {
        this.$toasted.info('Uploading file...');

        const formData = new FormData();
        formData.append('file', file);

        const { data } = await axios.post(process.env.VUE_APP_IMAGE_UPLOAD, formData);

        // Update the appropriate filePath based on upload type
        if (this.currentUploadType === 'otherTraining' && this.currentUploadIndex !== null) {
          this.updateOtherTrainingFilePath(this.currentUploadIndex, data.fileUrl);
        } else if (this.currentUploadType === 'cv') {
          this.updateCVFilePath(data.fileUrl);
        }

        this.$toasted.success('File uploaded successfully', { duration: 3000 });

      } catch (error) {
        this.$toasted.error('File upload failed', { duration: 3000 });
        // eslint-disable-next-line no-console
        console.error('Upload error:', error);
      }

      // Reset the input and tracking variables
      const input = event.target;
      input.value = '';
      this.currentUploadType = null;
      this.currentUploadIndex = null;
    },

    deleteQualification(id) {
      this.$_deleteEducationQualification(id, this.$AuthUser.id)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 3000 });
          this.loading = true;
          this.dialogDel = false;
          this.getQualifications();
        })
        .catch((error) => {
          this.$toasted.error(error.message, { duration: 3000 });
        });
    },

    getQualifications() {
      this.loading = true;
      this.educationalInfo = [];
      this.certificationInfo = [];
      this.membershipInfo = [];
      this.otherTrainingInfo = [];
      this.cvInfo = { filePath: null };

      this.$_employeeCertifications(this.$AuthUser.id).then((response) => {
        // Handle Educational Information
        if (response.data.educationalInfo && response.data.educationalInfo.length === 0) {
          this.addCredentials();
        } else {
          this.educationalInfo = response.data.educationalInfo || [];
          if (this.educationalInfo.length === 0) {
            this.addCredentials();
          }
        }

        // Handle Certification Information
        if (response.data.certificationInfo && response.data.certificationInfo.length === 0) {
          this.addCertifications();
        } else {
          this.certificationInfo = response.data.certificationInfo || [];
          if (this.certificationInfo.length === 0) {
            this.addCertifications();
          }
        }

        // Handle Membership Information
        if (response.data.membershipInfo && response.data.membershipInfo.length === 0) {
          this.addMembership();
        } else {
          this.membershipInfo = response.data.membershipInfo || [];
          if (this.membershipInfo.length === 0) {
            this.addMembership();
          }
        }

        // Handle Other Training Information
        if (response.data.otherTrainingInfo && response.data.otherTrainingInfo.length === 0) {
          this.addOtherTraining();
        } else {
          this.otherTrainingInfo = response.data.otherTrainingInfo || [];
          if (this.otherTrainingInfo.length === 0) {
            this.addOtherTraining();
          }
        }

        // Handle CV Information
        if (response.data.cvInfo) {
          this.cvInfo = response.data.cvInfo;
        }

        this.loading = false;
        this.edit = false;
      });
    },
  },

  mounted() {
    this.getQualifications();
  },
};
</script>

<style lang="css">

</style>